<template>
  <div class="answer">
    <div class="search-con">
      <el-input
        placeholder="请输入内容"
        v-model="searchAsk"
        class="input-with-select"
        @keyup.enter.native="enterDown"
      >
        <el-button
          slot="append"
          icon="el-icon-close"
          @click="closeSearchList"
          v-if="closeSearch"
        ></el-button>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchList"
          v-if="!closeSearch"
        ></el-button>
      </el-input>
      <el-switch v-model="askAllow" @change="changeAskAllow" :width="28" v-if="role == 3">
      </el-switch>
      <span class="allow fontColor" v-if="role == 3">{{ $t('askAnswer.允许提问') }}</span>
    </div>
    <div class="choose-add-list">
      <div class="answer-bar-header-choose">
        <el-popover
          placement="bottom"
          width="140"
          :visible-arrow="false"
          v-model="controlQA"
          popper-class="header-choose"
        >
          <ul class="answer-bar-header-control-content">
            <li @click="getLists(0)">
              <a href="javascript:;" :class="{ current: current == 0 }">{{
                $t('askAnswer.全部问答')
              }}</a>
            </li>
            <li @click="getLists(1)">
              <a href="javascript:;" :class="{ current: current == 1 }">
                {{ $t('askAnswer.已发布的问答') }}</a
              >
            </li>
            <li @click="getLists(2)">
              <a href="javascript:;" :class="{ current: current == 2 }">
                {{ $t('askAnswer.未发布的问答') }}</a
              >
            </li>
            <li @click="getLists(3)">
              <a href="javascript:;" :class="{ current: current == 3 }">
                {{ $t('askAnswer.已回答的问答') }}</a
              >
            </li>
            <li @click="getLists(4)">
              <a href="javascript:;" :class="{ current: current == 4 }">
                {{ $t('askAnswer.未回答的问答') }}</a
              >
            </li>
            <li @click="getLists(7)">
              <a href="javascript:;" :class="{ current: current == 7 }">
                {{ $t('askAnswer.我回答的') }}</a
              >
            </li>
            <li @click="getLists(5)">
              <a href="javascript:;" :class="{ current: current == 5 }">
                {{ $t('askAnswer.指派我的问答') }}</a
              >
            </li>
            <li @click="getLists(6)">
              <a href="javascript:;" :class="{ current: current == 6 }">
                {{ $t('askAnswer.过滤') }}</a
              >
            </li>
          </ul>
          <span slot="reference" class="answer-bar-header-control-text"
            >{{ $t(`askAnswer.${selectAnswer}`) }} <img :src="require('@/svg/pulldown.svg')"
          /></span>
        </el-popover>
      </div>
      <div class="answer-bar-select-open">
        <div class="answer-bar-header-select">
          <el-popover
            placement="bottom"
            :visible-arrow="false"
            v-model="controlTime"
            popper-class="header-choose"
            width="45"
          >
            <ul class="answer-bar-header-control-content">
              <li @click="getLists(current, 'ask_time')">
                <a href="javascript:;" :class="{ current: select == 'ask_time' }">
                  {{ $t('askAnswer.时间') }}</a
                >
              </li>
              <li @click="getLists(current, 'same_count')">
                <a href="javascript:;" :class="{ current: select == 'same_count' }">
                  {{ $t('askAnswer.同问') }}</a
                >
              </li>
            </ul>
            <span slot="reference" class="answer-bar-header-control-text"
              ><i class="answer-order"></i>{{ $t(`askAnswer.${selectText}`) }}
              <img :src="require('@/svg/pulldown.svg')"
            /></span>
          </el-popover>
        </div>
        <div class="answer-open" @click="closeOpenAllAnswer">
          <i class="icon-answer-open" v-if="closeAllAnswer"></i>
          <i v-else class="icon-answer-close"></i>
        </div>
      </div>
    </div>
    <div class="answer-con" v-show="askLists.length > 0">
      <el-scrollbar style="height: 100%" ref="scrollRef">
        <ul class="answer-con-list">
          <li v-for="item in askLists" :key="item.id">
            <div>
              <div class="answer-con-list-header">
                <div class="header-left">
                  <span class="answer-con-list-ask-allot" v-if="item.allotUserName">
                    {{ item.allotUserName }}
                  </span>
                  <span class="allot" v-if="item.allotUserName">{{ $t('askAnswer.答') }}</span>
                  <span class="answer-con-list-ask-status" v-show="item.publishStatus">{{
                    $t('askAnswer.已发布')
                  }}</span>
                  <span class="answer-con-list-ask-nopublish" v-show="!item.publishStatus">{{
                    $t('askAnswer.未发布')
                  }}</span>
                  <span class="answer-con-list-ask-name">{{ item.askUserName }}</span>
                  <span class="answer-con-list-ask-time">{{
                    dateFormat(new Date(item.askTime), 'HH:mm:ss')
                  }}</span>
                </div>
                <div class="header-right">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('askAnswer.同问')"
                    placement="top"
                  >
                    <i class="same-ask"></i>
                  </el-tooltip>
                  <span class="answer-con-list-ask-count">{{ item.sameCount }}</span>
                </div>
              </div>
              <div class="answer-con-list-ask-content">
                <span class="answer-con-list-ask-img"> {{ $t('askAnswer.问') }}</span
                ><span class="answer-sequence">{{ item.sequence }}.</span
                ><span
                  class="answer-con-list-ask-text"
                  v-html="quteChatContent(item.content)"
                ></span>
              </div>
              <div class="answer-con-list-ask-control">
                <div>
                  <div
                    class="answer-count"
                    @click="openCloseAnswer(item)"
                    v-if="item.replyCount > 0"
                  >
                    <span class="ask-answer" v-if="!item.replyCollapse"
                      >{{ item.replyCount }}个回答</span
                    ><span class="ask-answer" v-if="item.replyCollapse">收起回答</span
                    ><i class="icon-pull-down" :class="{ 'icon-pull-up': item.replyCollapse }"></i>
                  </div>
                </div>
                <div>
                  <el-button
                    type="primary"
                    size="small"
                    @click="handlePointer(item)"
                    v-if="item.allotUserId == ''"
                    >{{ $t('askAnswer.指定用户') }}</el-button
                  >
                  <el-button
                    class="change-ask-user"
                    type="primary"
                    size="small"
                    @click="handlePointer(item)"
                    v-if="item.allotUserId != ''"
                    >{{ $t('askAnswer.更换指定') }}</el-button
                  >
                  <el-button type="primary" @click="handleAsk(item)" size="small">{{
                    $t('askAnswer.回答')
                  }}</el-button>
                  <el-button
                    :type="item.publishStatus ? 'danger' : 'primary'"
                    size="small"
                    v-if="role == 3"
                    @click="handlePub(item)"
                    >{{ $t(`askAnswer.${item.publishStatus}`) }}</el-button
                  >
                </div>
              </div>
              <div v-show="item.replyCollapse" class="replay-content">
                <div class="replay-count">
                  <span class="answer-con-list-answer-img"> {{ $t('askAnswer.answer') }} </span>
                  <span class="ask-answer replay-ask">{{ item.replyCount }}个回答</span>
                </div>
                <ul>
                  <li
                    v-for="answer in item.qaReplyInfoVoList"
                    class="answer-con-list-answer-li"
                    :key="answer.id"
                  >
                    <div class="answer-con-list-answer-header" v-if="answer.showHeader !== false">
                      <span class="answer-con-list-answer-name">{{ answer.replyUserName }}</span>
                      <span
                        class="answer-con-list-answer-me main-color"
                        v-if="answer.replyUserId === userInfo.uid"
                        >{{ $t('askAnswer.我') }}</span
                      >
                      <span class="answer-con-list-answer-time">{{
                        dateFormat(new Date(answer.replyTime), 'HH:mm:ss')
                      }}</span>
                    </div>
                    <div class="answer-con-list-answer-content">
                      <span
                        class="answer-con-list-ask-text"
                        v-html="quteChatContent(answer.replyContent)"
                      ></span>
                    </div>
                  </li>
                </ul>
              </div>
              <el-divider></el-divider>
            </div>
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <div class="answer-con no-answer" v-show="askLists.length === 0">
      <i class="no-ask"></i>
      <span class="answer-bar-content-not" v-if="showTips">{{
        $t('askAnswer.暂不支持发送提问')
      }}</span>
      <span class="no-list" v-else>暂无问答</span>
    </div>
    <div class="show-tips" v-if="showTipsMessage !== ''">
      {{ $t(`askAnswer.${showTipsMessage}`) }}
    </div>
    <div class="ask-bar" v-if="!showTips">
      <el-button type="primary" @click="toAsk">{{ $t('askAnswer.去提问') }}</el-button>
    </div>
    <answerAsk :show="showAnswer" :ask="currentAnswer" @close="close" :title="askTitle"></answerAsk>
    <answerPointer
      :show="showPointer"
      :pointer="currentPointer"
      :id="currentPointerId"
      @closeP="closePointer"
    ></answerPointer>
  </div>
</template>
<script>
import { uuid, dateFormat, getParameter } from '@/utils/global';
import emojiList from '@/utils/emoji.json';
import {
  pubAnswer,
  askAnswerLists,
  publication,
  answerMoreLists,
  switchAnswer,
  getSwitchAnswer,
  addAnswering
} from '@/api/liveRequest/askAnswer';
import { pushRoomMessageFunc } from '@/utils/socketMessageDispose';
import answerAsk from '@/components/askAnswer/answer';
import answerPointer from '@/components/askAnswer/pointer';
import Bus from '@/components/doc/bus';

export default {
  name: 'answer',
  components: {
    answerAsk,
    answerPointer
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      controlItem: false, //显示隐藏控制项
      controlQA: false, //显示隐藏问答筛选
      showTips: true, //直播未开始显示不能问答
      sendChatNumber: 0, //字数
      askAllow: true, //是否允许提问
      askLists: [], //问答列表
      dateFormat: dateFormat,
      showAnswer: false, //显示隐藏回答弹框
      currentAnswer: {}, //传入当前回答
      showPointer: false, //显示隐藏指派弹框
      currentPointer: {}, //传入当前指派
      liveId: getParameter('liveId'),
      current: 0, //当前搜索条件 0全部问答 1已发布 2未发布 3已回答 4未回答 5指派给自己 6过滤短消息 7我回答的
      showTipsMessage: '', //TODO 提示语，暂时未使用
      pageNum: 1, //分页显示列表
      currentPointerId: '', //指派弹框id
      selectAnswer: '全部问答', //选择回答类型text
      searchAsk: '', //搜索问答
      controlTime: false, //显示隐藏同问时间弹框
      askTitle: '', //打开弹窗标题
      closeAllAnswer: true, //打开关闭全部回答 true 关闭 false 打开
      select: 'ask_time', //排序'ask_time'按提问时间排序'same_count'按同问个数排序
      selectText: '时间', //排序text
      closeSearch: false, //是否显示关闭搜索 false 不显示 true 显示
      currentTab: false, //当前tab false 当前不在问答tab
      numAnswer: 0 //当前问答数量
    };
  },
  computed: {
    quteChatContent() {
      return (chatInfo) => {
        return this.chatListHandle(chatInfo);
      };
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    },
    confId() {
      return this.$store.getters.confId;
    },
    // 主控权   1：有  0：无
    avctl() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl;
    },
    /** 2 直播中
        3 已过期
        4 已结束
        1 准备中
        0 未开始
        */
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    ccWebsocketClient() {
      return this.$store.getters.ccWebsocketClient;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    teamId() {
      return this.$store.getters.teamId;
    },
    groupOrder() {
      return this.$store.getters.groupOrder;
    },
    emojiListArr() {
      return emojiList;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    }
  },
  watch: {
    liveStartStatus: {
      immediate: true,
      handler(val) {
        // console.log(val, "val");
        if (val === 2) {
          this.showTips = false;
          //this.pageNum = 1;
          //this.askLists = [];
          //this.getLists(0);
          this.answerSwitch();
        } else {
          this.showTips = true;
        }
      }
    }
    // show: {
    //   immediate: true,
    //   handler(val) {
    //     console.log(val, 'show');
    //     if (val) {
    //       this.$nextTick(() => {
    //         this.handleScroll();
    //       });
    //     }
    //   }
    // }
  },
  mounted() {
    //收到问答消息
    pushRoomMessageFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
    Bus.$on('refreshAskList', () => {
      this.pageNum = 1;
      this.askLists = [];
      this.getLists(0);
      console.log('获取列表....');
      // this.$nextTick(() => {
      //   this.handleScroll();
      // });
    });

    console.log('初始化。。。。');
    //this.$refs.scrollRef.wrap.addEventListener('scroll', this.handleScroll);
    // this.$refs.chatMessageRef.addEventListener("paste", this.monitorPaste);
    // this.$nextTick(()=>{
    //   this.handleScroll();
    // })
  },
  // beforeDestroy() {
  //   this.$refs.scrollRef.wrap.removeEventListener('scroll', this.scrollList);
  // },
  methods: {
    /**
     * 添加enter键
     * @param e
     */
    enterDown(e) {
      const ev = e || window.event;
      // 如果是回车
      if (ev.keyCode === 13) {
        console.log('enter 13');
        this.searchList();
        ev.preventDefault();
        return false;
      }
    },
    monitorPaste(event) {
      event.preventDefault(); // 获取剪贴板数据
      let paste = (event.clipboardData || window.clipboardData).getData('text/plain');

      document.execCommand('insertText', false, paste);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          let clientHeight = this.$refs.scrollRef?.wrap.clientHeight;
          let height = document.querySelector('.answer-con-list')?.getBoundingClientRect().height;
          if (this.$refs.scrollRef) {
            this.$refs.scrollRef.wrap.scrollTop = height - clientHeight;
          }
        }, 240);
      });
    },
    /**
     * 处理表情包
     * @param {*} chatData
     */
    chatListHandle(chatData) {
      if (!chatData) return;
      let reg = RegExp('\\[1F60\\d{1,4}\\]', 'g');
      if (reg.test(chatData)) {
        emojiList.forEach((item) => {
          let rules = new RegExp(`\\[${item.codes}\\]`, 'g');
          let _imgNameUrl = require(`@/assets/emoji/${item.imgName}`);
          chatData = chatData.replace(
            rules,
            `<img codes='${item.codes}' src='${_imgNameUrl}' class='chatEditSpan' width='20px' height='20px'/>`
          );
        });
      }
      return chatData;
    },
    //TODO 看下是否只查了一次
    scrollList() {
      let scrollTop = this.$refs.scrollRef.wrap.scrollTop;
      console.log(this.$refs.scrollRef.wrap.scrollTop, 'gundong ');
      if (scrollTop <= 0 && this.askLists.length === this.pageNum * 20) {
        this.pageNum++;
        this.getLists(this.current);
      }
      //let clientHeight = this.$refs.scrollRef?.wrap.clientHeight;
      //let scrollHeight = this.$refs.scrollRef?.wrap.scrollHeight;
      // if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      if (scrollTop <= 0) {
        Bus.$emit('dot', false);
      }
    },
    /**
     * 监听是否滚动
     */
    handleScroll() {
      let el = this.$refs.scrollRef?.wrap;
      //console.log(el, '滚动');
      el.onscroll = async () => {
        //console.log(el.scrollTop, '滚动scroll');
        if (el.scrollTop < 20) {
          Bus.$emit('dot', false);
        }
        // console.log(el.scrollTop, '滚动scroll');
        // console.log(el.clientHeight, '高度');
        // console.log(el.scrollHeight, '滚动高度');
        // console.log(this.askLists.length, '数量');
        // console.log(this.pageNum, 'pageNum');
        if (
          Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight &&
          this.askLists.length >= this.pageNum * 20
        ) {
          this.pageNum++;
          this.getLists(this.current);
        }
      };
    },
    /**
     * 获取是否可以提问
     */
    async answerSwitch() {
      const { data, code } = await getSwitchAnswer(this.liveId, this.liveToken);
      if (code == 200) {
        this.askAllow = data.switchType ? true : false;
      }
    },
    /**
     * 打开关闭提问
     * @param {*} val
     */
    async changeAskAllow(val) {
      console.log(val, 'askAllow');
      let params = {
        switchType: val ? 1 : 0,
        webcastId: this.liveId
      };
      const { data, code, message } = await switchAnswer(params, this.liveToken);
    },
    //TODO 全部展开把回答个数置零，判断用，如果个数有其它用途需要加新值 2022-11-09 by miaoxiuhong
    async handleMore(item) {
      let params = {
        qaId: item.qaId,
        pageNum: 1,
        pageSize: 10000
      };
      const { data, code } = await answerMoreLists(params, this.liveToken);
      if (code == 200) {
        let qaReplyInfoVoList = data.list;
        for (let i = 1; i < qaReplyInfoVoList.length; i++) {
          if (qaReplyInfoVoList[i].replyUserId === qaReplyInfoVoList[i - 1].replyUserId) {
            qaReplyInfoVoList[i].showHeader = false;
          }
          // if(qaReplyInfoVoList.length === 0) {
          //   qaReplyInfoVoList[i].replyCollapse = false;
          // }
        }
        item.qaReplyInfoVoList = qaReplyInfoVoList;
        console.log(qaReplyInfoVoList, '展开后回答的列表');
      }
    },
    handleCollapse(item) {
      item.replyCollapse = false;
      let first = item.qaReplyInfoVoList.slice(0, 1);
      item.qaReplyInfoVoList = first;
    },

    /**
     * 点击展开关闭回答
     * @param item
     */
    openCloseAnswer(item) {
      console.log(item, 'openCloseAnswer');
      item.replyCollapse = !item.replyCollapse;
      if (item.replyCollapse) {
        this.handleMore(item);
      }
      this.$forceUpdate();
    },
    /**
     * 开启关闭全部回答
     */
    closeOpenAllAnswer() {
      this.closeAllAnswer = !this.closeAllAnswer;
      if (this.closeAllAnswer) {
        this.askLists.forEach((item) => {
          item.replyCollapse = false;
        });
      } else {
        this.askLists.forEach((item) => {
          if (item.replyCount > 0) {
            item.replyCollapse = true;
            this.handleMore(item);
          }
        });
      }
    },

    /**
     * 发布，取消发布
     * @param {*} item
     */
    async handlePub(item) {
      let params = {
        publishStatus: item.publishStatus == 0 ? 1 : 0,
        qaId: item.qaId
      };
      const { code, msg } = await publication(params, this.liveToken);
      if (code !== 200) {
        this.$messager.error(msg);
      }
    },
    /**
     * 搜索问答
     */
    searchList() {
      this.pageNum = 1;
      if (this.searchAsk !== '') {
        this.closeSearch = true;
      } else {
        this.closeSearch = false;
      }
      this.getLists(this.current);
    },
    closeSearchList() {
      this.pageNum = 1;
      this.closeSearch = false;
      this.searchAsk = '';
      this.getLists(this.current);
    },
    /**
     * 获取问答列表
     */
    async getLists(val, filed) {
      let orderFiled = '';
      if (val !== this.current || (filed && filed !== this.select)) {
        this.pageNum = 1;
      }
      if (this.pageNum === 1) {
        this.askLists = [];
      }

      if (filed) {
        orderFiled = filed;
      } else {
        orderFiled = this.select;
      }

      if (orderFiled === 'same_count') {
        this.selectText = '同问';
      } else {
        this.selectText = '时间';
      }

      let params = {
        confId: this.confId,
        order: 1,
        pageNum: this.pageNum,
        orderFiled: orderFiled,
        content: encodeURI(this.searchAsk),
        pageSize: 20
      };
      console.log(params, '获取问答列表参数');
      switch (val) {
        case 0:
          this.selectAnswer = '全部问答';
          break;
        case 1:
          params.publishStatus = 1; //已发布的
          this.selectAnswer = '已发布的问答';
          break;
        case 2:
          params.publishStatus = 0; //未发布的
          this.selectAnswer = '未发布的问答';
          break;
        case 3:
          params.replyStatus = 1; //已回答的
          this.selectAnswer = '已回答的问答';
          break;
        case 4:
          params.replyStatus = 0; //未回答的
          this.selectAnswer = '未回答的问答';
          break;
        case 5:
          params.onlyMe = true; //分配给我
          this.selectAnswer = '指派我的问答';
          break;
        case 6:
          params.shortFiltration = true; //过滤
          this.selectAnswer = '过滤问题';
          break;
        case 7:
          params.meAnswer = true; //我回答的
          this.selectAnswer = '我回答的';
          break;
      }
      this.current = val;
      this.select = orderFiled;
      this.controlQA = false;
      this.controlTime = false;
      const { data, code } = await askAnswerLists(params, this.liveToken);

      if (code == 200) {
        if (!this.closeAllAnswer) {
          data.list.forEach((item) => {
            if (item.replyCount > 0) {
              item.replyCollapse = true;
              this.handleMore(item);
            }
          });
        }
        let lists = this.askLists.concat(data.list);
        let jsonStringArray = lists.map((obj) => JSON.stringify(obj));
        let uniqueJsonStringArray = [...new Set(jsonStringArray)];
        let uniqueObjectArray = uniqueJsonStringArray.map((jsonStr) => JSON.parse(jsonStr));
        this.askLists = uniqueObjectArray;
        //console.log(this.askLists, '获取问答列表');
        Bus.$emit('dot', false);
        if (this.pageNum === 1) {
          this.$nextTick(() => {
            this.handleScroll();
          });
        }
      }
    },
    async close() {
      this.showAnswer = false;
      // if (this.askLists.length === 0) {
      //   this.getLists(0);
      // }
    },
    closePointer() {
      this.showPointer = false;
      this.currentPointerId = '';
      this.currentPointer = {};
    },
    controlMaxLength(e) {
      const ev = e || window.event;
      // 如果是回车
      if (ev.keyCode == 13) {
        this.releaseFun();
        ev.preventDefault();
        return false;
      }
    },
    /** 生成一个通信32位id */
    getChatHeadId() {
      return `${uuid(15, 62)}${new Date().getTime()}`;
    },
    /**问答提问 */
    async releaseFun() {
      let chatMessageRef = this.$refs.chatMessageRef;
      console.log(chatMessageRef.innerHTML, 'shuru ');
      let contentMath = chatMessageRef.innerHTML
        .replace(/<img[^>]*>/gi, 'b')
        .replace(/&nbsp;/g, ' ');
      console.log(contentMath, '输入个数');
      if (contentMath.length < 5) {
        this.showTipsMessage = '提问字数不能小于5个';
        setTimeout(() => {
          this.showTipsMessage = '';
        }, 3000);
        return;
      }
      let mssageVal = chatMessageRef.innerHTML
        .replace(/<img[^>]*>/gi, (matchVal) => {
          let codes = this.parseToDOM(matchVal)[0].getAttribute('codes');
          return `[${codes}]`;
        })
        .replace(/&nbsp;/g, ' ');
      this.showTipsMessage = '';
      const { data, code, message } = await pubAnswer({ content: mssageVal }, this.liveToken);

      chatMessageRef.innerHTML = '';
      this.sendChatNumber = 0;
    },
    /**
     * 打开问答
     */
    async handleAsk(item) {
      const { code, data } = await addAnswering(item.qaId, this.liveToken);
      this.showAnswer = true;
      this.currentAnswer = item;
      this.askTitle = this.$t('askAnswer.回答');
      if (code == 200) {
        console.log(data, 'data');
        //this.numAnswer = data;
        Bus.$emit('updateNumAnswer', data);
        // this.getAnswerCount(item.qaId)
      }
    },
    /**
     * 去提问
     */
    toAsk() {
      this.showAnswer = true;
      this.currentAnswer = false;
      this.askTitle = this.$t('askAnswer.提问');
    },
    /**
     * 打开指定用户
     * @param {*} item
     */
    handlePointer(item) {
      this.showPointer = true;
      console.log('item', item);
      this.currentPointer = item;
      this.currentPointerId = item.allotUserId;
    },
    parseToDOM(str) {
      var div = document.createElement('div');
      if (typeof str == 'string') div.innerHTML = str;
      return div.childNodes;
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7127:
          this.disposeCustomMessage_7127(msg.requestData);
          break;
        case 7107:
          this.disposeCustomMessage_7107(msg.requestData);
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case 'qa/publish':
            this.publishQa(requestData);
            // if (this.current != 0) {
            //   this.getLists(this.current);
            // }
            break;
          case 'qa/reply':
            this.qaReplay(requestData);
            // if (this.current != 0) {
            //   this.getLists(this.current);
            // }
            break;
          case 'qa/with_question':
            this.withQuestion(requestData);
            break;
          case 'qa/switch_webcast_config':
            this.switchConfig(requestData);
            break;
          case 'qa/webcast_config':
            if (requestData.switchType) {
              this.pageNum = 1;
              this.askLists = [];
              this.getLists(this.current);
            }
            break;
        }
      }
    },
    switchConfig(data) {
      this.askAllow = data.switchType ? true : false;
    },
    withQuestion(data) {
      this.askLists.map((item) => {
        if (item.qaId === data.qaId) {
          item.sameCount = data.sameCount;
        }
      });
    },
    /**
     * 7107 问答回复
     * @param data
     */
    qaReplay(data) {
      let tag = -1;
      console.log('返回的回复数据', data);
      console.log('返回的回复数据id', data.qaId);
      this.askLists.forEach((item, index) => {
        if (item.qaId === data.qaId) {
          item.replyCount = data.replyCount;
          if (item.qaReplyInfoVoList.length === 0) {
            item.qaReplyInfoVoList.push(data);
            if (!this.closeAllAnswer) {
              item.replyCollapse = true;
            }
          } else {
            let voListCount = item.qaReplyInfoVoList.length;

            if (item.replyCollapse) {
              if (data.replyUserId === item.qaReplyInfoVoList[voListCount - 1].replyUserId) {
                data.showHeader = false;
              }
              item.qaReplyInfoVoList.push(data);
            }
          }
          tag = index;
        }
      });
      if ((this.current === 3 || this.current === 4) && tag !== -1) {
        console.log('改变askLists');
        //if(this.askLists.length >= 20) {
        //this.getLists(this.current);
        // } else {
        this.askLists.splice(tag, 1);
        // }
      }
      this.$forceUpdate();
    },
    publishQa(data) {
      //let tag = -1;
      this.askLists.forEach((item) => {
        if (item.qaId === data.qaId) {
          item.publishStatus = data.publishStatus;
          // if (!this.closeAllAnswer) {
          //   item.replyCollapse = true;
          //   this.handleMore(item);
          // }
          //tag = index;
        }
      });
      // console.log(tag, '当前tag');
      // if ((this.current === 1 || this.current === 2) && tag !== -1) {
      //   console.log('改变askLists');
      //   this.askLists.splice(tag, 1);
      // }
    },
    disposeCustomMessage_7127(requestData) {
      //let clientHeight = this.$refs.scrollRef?.wrap.clientHeight;
      let scrollTop = this.$refs.scrollRef?.wrap.scrollTop;
      //let scrollHeight = this.$refs.scrollRef?.wrap.scrollHeight;
      if (requestData.event) {
        switch (requestData.event) {
          case 'qa/add':
            // console.log(Object.assign(requestData, { status: 0 }), "tianjia");
            //requestData.time = dateFormat(new Date(requestData.askTime),"HH:ss")
            if (!this.show) {
              Bus.$emit('dot', true);
            } else {
              if (this.current !== 0 || this.searchAsk !== '') {
                Bus.$emit('dot', true);
                console.log('emitfalse 加上小红点');
              } else {
                if (scrollTop > 0) {
                  console.log('emittrue 加上小红点');
                  Bus.$emit('dot', true);
                } else {
                  console.log('emitfalse 去掉小红点');
                  Bus.$emit('dot', false);
                }
                this.askLists.unshift(
                  Object.assign(requestData, {
                    publishStatus: 0,
                    qaReplyInfoVoList: [],
                    sameCount: 0,
                    allotUserId: '',
                    allotUserName: ''
                  })
                );
              }
            }
            break;
          case 'qa/allot':
            this.askLists.map((item) => {
              if (item.qaId === requestData.qaId) {
                item.allotUserName = requestData.userName;
                item.allotUserId = requestData.userId;
              }
            });
            if (this.current != 0) {
              this.getLists(this.current);
            }
        }
      }
    },
    /**监听输入 */
    changeText() {
      let _chatMessageRef = this.$refs.chatMessageRef;
      let mssageVal = _chatMessageRef.innerHTML
        .replace(/<img[^>]*>/gi, 'a')
        .replace(/&nbsp;/g, 'b');

      if (mssageVal.length > 140) {
        setTimeout(() => {
          _chatMessageRef.innerHTML = this.getStr(
            _chatMessageRef.innerHTML.replace(/&nbsp;/g, ' ')
          );
          this.sendChatNumber = 140;
          this.keepLastIndex(_chatMessageRef);
        }, 0);
        return;
      }
      this.sendChatNumber = mssageVal.length;
    },
    getStr(str) {
      const reg = /((<[\s]*img.*?src=?(.*?)?\s.*?>)|[\d\D]){0,140}/gi;
      return reg.exec(str)[0];
    },
    // 光标移至最后
    keepLastIndex(obj) {
      obj.focus();
      document.execCommand('selectAll', false, null);
      document.getSelection().collapseToEnd();
    },
    /**表情选择 */
    emojiClick(item) {
      let _imgNameUrl = require(`@/assets/emoji/${item.imgName}`);
      const Img = `<img codes="${item.codes}" src="${_imgNameUrl}" class="chatEditSpan" width="20px" height='20px'/>`;
      let obj = this.$refs.chatMessageRef;
      let range, node;
      if (!obj.hasfocus) {
        obj.focus();
      }
      if (window.getSelection && window.getSelection().getRangeAt) {
        range = window.getSelection().getRangeAt(0);
        range.collapse(false);
        node = range.createContextualFragment(Img);
        let c = node.lastChild;
        range.insertNode(node);
        if (c) {
          range.setEndAfter(c);
          range.setStartAfter(c);
        }
        let j = window.getSelection();
        j.removeAllRanges();
        j.addRange(range);
      } else if (document.selection && document.selection.createRange) {
        document.selection.createRange().pasteHTML(Img);
      }
      this.changeText(true);
    },
    emojiUrl(item) {
      return require(`@/assets/emoji/${item.imgName}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.header-right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.header-left {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.choose-add-list {
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
}
.answer {
  height: calc(100% - 59px);

  &-con {
    height: calc(100% - 129px);
    overflow-y: hidden;
    color: #fff;
    font-size: 12px;
    &-list {
      &-answer {
        &-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-time {
          margin-left: 5px;
          flex-shrink: 0;
        }
        &-li {
          margin: 2px 0;
          border-bottom: 1px solid #393f6c;
          padding: 6px 0;
          &:last-child {
            border-bottom: none;
          }
        }
        &-content {
          display: flex;
          line-height: 1.5;
        }
        &-header {
          display: flex;
          margin-bottom: 4px;
          color: #8a8f99;
          font-size: 12px;
          line-height: 1.5;
        }
        &-me {
          // color: #409eff;
          flex-shrink: 0;
        }
        &-img {
          margin-right: 6px;
          flex-shrink: 0;
          background: url('../../assets/images/answer.png') no-repeat 0 0;
          width: 18px;
          height: 18px;
          line-height: 18px;
          background-size: cover;
          font-size: 10px;
          font-weight: 800;
        }
      }
      padding: 10px;
      &-header {
        display: flex;
        padding: 8px 0px;
        align-items: center;
        justify-content: space-between;
        line-height: 1;
      }
      &-ask {
        &-allot {
          color: #3986ee;
          max-width: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-control {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;
          line-height: 1;
        }
        &-name {
          margin-right: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 80px;
          color: #8a8f99;
        }
        &-time {
          flex-shrink: 0;
          color: #8a8f99;
        }
        &-img {
          margin-right: 6px;
          flex-shrink: 0;
          background: url('../../assets/images/ask.png') no-repeat 0 0;
          width: 18px;
          height: 18px;
          line-height: 18px;
          background-size: cover;
          font-size: 10px;
          font-weight: 800;
        }
        &-content {
          display: flex;
          line-height: 1.5;
        }
        &-status {
          background: #3986ee;
          border-radius: 2px;
          margin-right: 6px;
          padding: 0 4px;
          font-size: 10px;
          line-height: 2;
        }
        &-nopublish {
          background: #ff7574;
          border-radius: 2px;
          margin-right: 6px;
          padding: 0 4px;
          font-size: 10px;
          line-height: 2;
        }
        &-text {
          text-align: left;
          word-break: break-all;
        }
      }
    }
  }

  &-bar {
    height: 130px;
    color: #fff;
    font-size: 12px;
    &-header {
      display: flex;
      height: 30px;
      background: #333a64;
      justify-content: space-between;
      align-items: center;
      padding: 0px 7px 0 14px;
      line-height: 1;
      &-control {
        &-text {
          cursor: pointer;
        }
        &-content {
          font-size: 12px;
          font-weight: 400;
          color: #acb2bf;
          text-align: center;
          li {
            line-height: 30px;
            height: 30px;
            cursor: pointer;
            a {
              color: #acb2bf;
              text-decoration: none;
            }
            a.current {
              color: #3986ee;
            }
          }
        }
      }
    }
    &-content {
      display: flex;
      line-height: 1;
      &-not {
        color: #acb2bf;
        text-align: left;
        margin: 12px 0 0 10px;
      }
    }
  }
}

[data-theme='Orange'] .answer-con-list-answer-li {
  border-color: #e0e1e6;
}
[data-theme='Orange'] .answer-con-list-ask-text {
  color: #494a4d !important;
}
:deep(.el-button--small) {
  padding: 6px;
}
:deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
:deep(.el-divider) {
  background-color: #2c325c;
}
[data-theme='Orange'] .answer-con-list-ask-status {
  background-color: #f89b33;
  color: #fff;
}
[data-theme='Orange'] .answer-con-list-ask-nopublish {
  color: #fff;
}
.chat-edit {
  cursor: text;
  overflow-x: hidden;
  overflow-y: auto;
  word-break: normal;
  outline: none;
  font-size: 12px;
  text-align: left;
  padding: 9px 5px 0;
  height: 54px;
  color: $white-color;
  white-space: pre-wrap;
}

.chat-edit:empty::before {
  content: attr(placeholder);
  color: #acb2bf;
  font-size: 12px;
}

.bottom-send-msg {
  height: 100px;
  padding: 0 9px;
  width: 300px;

  .bottom-bar-handel {
    display: flex;
    justify-content: space-between;
    height: 36px;
    align-items: center;
    padding: 0px 5px;
    line-height: 1;
    .bottom-bar-img {
      img {
        width: 20px;
        cursor: pointer;
      }

      .mr10 {
        margin-right: 10px;
      }

      .bottom-bar-emoji:hover ~ .emoji-list {
        display: inline-block;
      }
    }

    .bottom-bar-btn {
      button {
        background-color: $bule-color;
        color: $white-color;
        border: none;
        border-radius: 6px;
      }
    }
  }
}
.chatEditSpan {
  width: 20px;
  height: 20px;
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  vertical-align: middle;
  display: flex;
}

.emoji-list {
  display: none;
  width: 240px;
  position: absolute;
  bottom: 20px;
  text-align: left;
  background-color: #2d3052;
  border-radius: 6px;
  left: 0;
  padding: 6px;
  z-index: 1000;
  li {
    display: inline-block;
    padding: 4px;
    border-radius: 2px;

    > img {
      margin: 0px 3px;
      display: inline-block;
      width: 20px;
    }
  }
}

.emoji-list:hover {
  display: inline-block;
}
.allow {
  font-size: 12px;
  color: #acb2bf !important;
}
.more-answer {
  width: 100px;
  height: 24px;
  line-height: 24px;
  background: #333a64;
  border-radius: 2px;
  cursor: pointer;
  &-content {
    display: flex;
    line-height: 1.5;
    color: #fff;
    align-items: center;
  }
  &-collapse {
    width: 52px;
    height: 24px;
    background: #333a64;
    border-radius: 2px;
    line-height: 24px;
    margin-top: 10px;
    cursor: pointer;
  }
}
.change-ask-user {
  border-radius: 2px;
  border: 1px solid #3986ee;
  background: transparent;
  color: #3986ee;
}
.show-tips {
  position: absolute;
  z-index: 1000;
  bottom: 130px;
  right: 70px;
  font-size: 12px;
  color: #fff;
  background: #000;
  opacity: 0.9;
  display: inline-block;
  width: 140px;
  height: 30px;
  line-height: 30px;
}
.allot {
  color: #409eff;
  margin-right: 5px;
}
[data-theme='Orange'] .allot {
  color: #f89b33;
}
.ask-bar {
  padding: 16px;
  ::v-deep .el-button--primary {
    padding: 5px 20px;
  }
}
[data-theme='Orange'] .ask-bar {
  ::v-deep .el-button--primary {
    background-color: #f89b33 !important;
    color: #fff !important;
  }
}
.search-con {
  display: flex;
  align-items: center;
  padding: 0 10px 12px;
  line-height: 1;
  ::v-deep .el-input__inner {
    height: 32px;
    font-size: 12px;
    border: 0 none;
  }
  ::v-deep .el-input-group {
    width: 185px;
    background-color: #333a64;
    margin-right: 13px;
  }
  ::v-deep .el-button {
    padding: 0;
  }
  ::v-deep .el-input-group__append {
    background-color: #333a64;
    border: 0 none;
  }
  ::v-deep .el-switch {
    height: 14px;
    line-height: 14px;
    margin-right: 6px;
  }
  ::v-deep .el-switch__core {
    height: 16px;
    &:after {
      top: 0;
      width: 14px;
      height: 14px;
    }
  }
}
[data-theme='Orange'] .search-con {
  ::v-deep .el-input-group {
    background-color: #fff;
  }
  ::v-deep .el-input-group__append {
    background-color: #fff;
  }
}
.answer-bar-header-choose {
  min-width: 49px;
  height: 28px;
  background: #2c325c;
  border-radius: 4px;
  font-size: 12px;
  color: #acb2bf;
  line-height: 28px;
  padding: 0 5px;
}
[data-theme='Orange'] .answer-bar-header-choose {
  background: #fff;
  color: #acb2bf;
}
.answer-bar-header-select {
  width: 68px;
  height: 28px;
  background: #2c325c;
  border-radius: 4px;
  font-size: 12px;
  color: #acb2bf;
  line-height: 28px;
  margin-right: 12px;
}
[data-theme='Orange'] .answer-bar-header-select {
  background: #fff;
  color: #acb2bf;
}
.answer-bar-select-open {
  display: flex;
  line-height: 1;
}
.answer-open {
  width: 28px;
  height: 28px;
  background: #2c325c;
  border-radius: 4px;
  font-size: 12px;
  color: #acb2bf;
  line-height: 28px;
  display: flex;
  line-height: 1;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
[data-theme='Orange'] .answer-open {
  background: #fff;
  color: #acb2bf;
}
.no-ask {
  width: 120px;
  height: 69px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/no-ask.svg');
}
[data-theme='Orange'] .no-ask {
  background-image: url('../../svg/no-ask-light.svg');
}
.no-answer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: 1;
}
.no-list {
  color: #acb2bf;
  font-size: 12px;
  margin-top: 23px;
}
.answer-order {
  width: 14px;
  height: 10px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/answer-order.svg');
}
.icon-answer-open {
  width: 17px;
  height: 14px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/close-answer.svg');
}
.icon-answer-close {
  width: 17px;
  height: 14px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/open-answer.svg');
}
.same-ask {
  width: 13px;
  height: 13px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/same-ask-dark.svg');
}
.header-right .answer-con-list-ask-count {
  color: #8a8f99 !important;
  margin-left: 5px;
}
::v-deep .el-divider--horizontal {
  margin: 12px 0;
}
.answer-count {
  height: 24px;
  background: #333a64;
  border-radius: 4px;
  color: #3986ee;
  font-size: 12px;
  display: flex;
  line-height: 1;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  cursor: pointer;
}
[data-theme='Orange'] .answer-count {
  background: #f5f5f5;
  border: 1px solid #f89b33;
  color: #f89b33;
}
.icon-pull-down {
  width: 7px;
  height: 4px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-left: 2px;
  background-image: url('../../svg/arrow-blue.svg');
}
[data-theme='Orange'] .icon-pull-down {
  background-image: url('../../svg/arrow-orange.svg');
}
.icon-pull-up {
  transform: rotate(180deg);
}
.replay-content {
  background: #2c325c;
  border-radius: 4px;
  padding: 8px 8px 2px;
  margin-top: 6px;
}
[data-theme='Orange'] .replay-content {
  background: #fdfdfd;
}
.replay-count {
  display: flex;
  margin-bottom: 5px;
  align-items: center;
  line-height: 1.5;
}
.answer-sequence {
  flex-shrink: 0;
}
[data-theme='Orange'] .replay-ask,
[data-theme='Orange'] .answer-sequence {
  color: #494a4d;
}
.answer-bar-header-control-text {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-left: 2px;
  }
}
::v-deep .el-switch.is-checked .el-switch__core::after {
  margin-left: -14px;
}
</style>
<style>
.header-choose {
  min-width: 30px;
}
</style>
